import { AXNUIThemingLabelComponent } from "@containers/common/axnui-theming-preview-container/axnui-theming-label-component/axnui-theming-label-component";
import { AXNUITelephoneInput } from "@iddataweb/idw-common-ui/containers";
import commonStyles from "@styles/common.less";

type AXNUIThemingTelephoneInputComponentProps = {
    id: string;
    isRequired: boolean;
    label: string;
};

export const AXNUIThemingTelephoneInputComponent = (props: AXNUIThemingTelephoneInputComponentProps) => {
    const { id, isRequired, label } = props;

    return (
        <div className={commonStyles.axnuiPreviewInputContainer}>
            <AXNUIThemingLabelComponent
                controlId={`attribute-input-${id}`}
                label={label}
                isRequired={isRequired}
            />

            <AXNUITelephoneInput
                title={""}
                idPrefix={""}
                defaultCountry={"us"}
                disabled={false}
                isOptional={!isRequired}
                phoneNumber={{ phone: "", dialCode: "1" }}
                onChange={async () => { }}
                onBlur={() => { }}
                readOnly={true}
                className={"form-control react-international-phone-input"} />
        </div >
    );
};